<div
  class="sz-run-row"
  [class.sz-run-row--best]="best()"
  [class.sz-run-row--interactive]="interactive()"
  [attr.tabindex]="interactive() ? 0 : null"
  [attr.role]="interactive() ? 'button' : null"
  (click)="onEdit()">
  <span class="sz-run-row__index">{{ formatIndex() }}</span>
  <span class="sz-run-row__value">
    {{ value() }}
    @if (unit(); as unitText) {
      <span class="sz-run-row__unit">{{ unitText }}</span>
    }
  </span>
  @if (best()) {
    <span class="sz-run-row__best">BEST</span>
  }
  @if (interactive()) {
    <button type="button" class="sz-run-row__remove" aria-label="Delete run" (click)="onRemove($event)">
      <sz-icon name="x" [size]="12" />
    </button>
  }
</div>
